//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PictureResponsive from '~/components/PictureResponsive.vue';

export default {
  name: 'Kickboxing_Details',
  components: {
    PictureResponsive,
  },
  data: () => ({
    img_url: '/v4/fc-kickboxing-taraus-001.jpg',
  }),
};
